import { BigNumberJs } from 'lib/BigNumber';

type QrData = {
  delegatedPrivateKey: string;
  nonce: string;
  custodyWalletAddress: string;
  authorizationSignature: string;
};

const NONCE_REGEX = /^(.{8})-(.{4})-(.{4})-(.{4})-(.{12})$/;
const NONCE_REGEX_OUTPUT = /^(.{8})(.{4})(.{4})(.{4})(.{12})$/;

export function parseSyncQrCompressedNumsPayload(text: string): QrData {
  const totalLength = 64 + 32 + 40 + 130;
  if (text.length < totalLength - 4) {
    // Add small diff as we might be missing leading 0s
    throw new Error('Incorrect QR Code');
  }
  // Convert to hex and make sure we didn't lose leading 0s
  const hexLikeString = BigNumberJs(text)
    .toString(16)
    .padStart(totalLength, '0');
  // 2x 64 32 40 130
  const match = hexLikeString.match(/^(.{64})(.{32})(.{40})(.{130})$/);

  if (!match) {
    throw new Error('Incorrect QR Code');
  }

  const nonceWihtoutDashes = match[2];
  const nonce = nonceWihtoutDashes.match(NONCE_REGEX_OUTPUT);
  if (!nonce) {
    throw new Error('Incorrect QR Code (err-nonce)');
  }
  return {
    delegatedPrivateKey: `0x${match[1]}`,
    nonce: nonce.slice(1).join('-'),
    custodyWalletAddress: `0x${match[3]}`,
    authorizationSignature: `0x${match[4]}`,
  };
}

/** Compress to 2 digit pairs:
 * 
    Remove 0x from addresses/PK
    Remove dashes from nonce
    Concat all to single string
    Convert each char (hex) to number (add leading 0 if number smaller than 10)

    Result is like: 01 12 15 05 ... (without spaces)
 */
export function generateSyncQrCompressedNumsPayload(data: QrData): string {
  const delegatedPrivateKey = data.delegatedPrivateKey.replace(/^0x/, '');
  const nonce = data.nonce;
  const custodyWalletAddress = data.custodyWalletAddress.replace(/^0x/, '');
  const authorizationSignature = data.authorizationSignature.replace(/^0x/, '');
  if (
    delegatedPrivateKey.length !== 64 ||
    nonce.length !== 36 /* 32 without dashes */ ||
    custodyWalletAddress.length !== 40 ||
    authorizationSignature.length !== 130
  ) {
    throw new Error('QR Code generate error - sumcheck fail');
  }
  // acca2080-e1fc-11ee-a2a6-2379a403a7b7 to acca2080e1fc11eea2a62379a403a7b7
  const nonceMatch = nonce.match(NONCE_REGEX);
  if (!nonceMatch || nonceMatch.length !== 6) {
    throw new Error('QR Code generate error - nonce sumcheck fail');
  }
  const hexLikeString = [
    delegatedPrivateKey,
    nonceMatch.slice(1).join(''),
    custodyWalletAddress,
    authorizationSignature,
  ].join('');

  if (
    hexLikeString.includes(' ') ||
    hexLikeString.includes('-') ||
    hexLikeString.includes('x')
  ) {
    throw new Error('QR Code generate error - unexpected char');
  }

  console.log('[QrSync] hexlike', hexLikeString);

  return BigNumberJs(`0x${hexLikeString}`).toString();
}

// Old way using string instead of numbers
// Only revert to this if we need to transfer non-hex values

// export function parseSyncQrPayload(text: string): QrData {
//   const textParts = text.split(' ');
//   if (textParts.length !== 4) {
//     throw new Error('Invalid QR Code data');
//   }
//   const [part1, part2, part3, part4] = textParts;
//   return {
//     delegatedPrivateKey: `0x${part1}`,
//     nonce: part2,
//     custodyWalletAddress: `0x${part3}`,
//     authorizationSignature: `0x${part4}`,
//   };
// }

// export function generateSyncQrPayload(data: QrData): string {
//   return [
//     data.delegatedPrivateKey.replace(/^0x/, ''),
//     data.nonce,
//     data.custodyWalletAddress.replace(/^0x/, ''),
//     data.authorizationSignature.replace(/^0x/, ''),
//   ].join(' ');
// }
//
// export function generateSyncQrBufferPayload(data: QrData): Buffer {
//   const delegatedPrivateKey = data.delegatedPrivateKey.replace(/^0x/, '');
//   const nonce = data.nonce;
//   const custodyWalletAddress = data.custodyWalletAddress.replace(/^0x/, '');
//   const authorizationSignature = data.authorizationSignature.replace(/^0x/, '');
//   if (
//     delegatedPrivateKey.length !== 64 ||
//     nonce.length !== 36 /* 32 without dashes */ ||
//     custodyWalletAddress.length !== 40 ||
//     authorizationSignature.length !== 130
//   ) {
//     throw new Error('QR Code generate error - sumcheck fail');
//   }
//   // acca2080-e1fc-11ee-a2a6-2379a403a7b7 to acca2080e1fc11eea2a62379a403a7b7
//   const nonceArr = nonce.split('-');
//   if (
//     nonceArr[0].length !== 8 ||
//     nonceArr[1].length !== 4 ||
//     nonceArr[2].length !== 4 ||
//     nonceArr[3].length !== 4 ||
//     nonceArr[4].length !== 12
//   ) {
//     throw new Error('QR Code generate error - nonce sumcheck fail');
//   }
//   const hexLikeString = [
//     delegatedPrivateKey,
//     nonceArr.join(''),
//     custodyWalletAddress,
//     authorizationSignature,
//   ].join('');
//   if (
//     hexLikeString.includes(' ') ||
//     hexLikeString.includes('-') ||
//     hexLikeString.includes('x')
//   ) {
//     throw new Error('QR Code generate error - unexpected char');
//   }
//   return Buffer.from(hexLikeString, 'hex');
// }
